import React from 'react'
import { Button } from '@augmentt-dev/ui-components'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import useFormState from '../../../../hooks/useFormState'

const propTypes = {
  submitButtonMessageId: PropTypes.string,
  formId: PropTypes.string,
}

function FormButtons({ formId = undefined, submitButtonMessageId = 'GENERAL.SAVE' }) {
  const history = useHistory()
  const [{ isInvalid }] = useFormState()

  return (
    <div>
      <Button variant="link" onClick={() => history.goBack()}>
        <FormattedMessage id="GENERAL.CANCEL" />
      </Button>
      <Button type="submit" variant="primary" form={formId} disabled={isInvalid}>
        <FormattedMessage id={submitButtonMessageId} />
      </Button>
    </div>
  )
}

FormButtons.propTypes = propTypes

export default FormButtons
